import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { posterFromSlug } from "../utils/posterFromSlug";

function GameInner({slidersFeatures, tabKey}) {
  const EMPTY_IMG = 'data:image/gif;base64,R0lGODlhAQABAAAAACw='; // 1x1 transparent to stop retries
  const [activeKey, setActiveKey] = useState(tabKey);
  const [winners, setWinners] = useState([]);
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [failedImages, setFailedImages] = useState({});
  const scrollRef = useRef(null);
  const [translateY, setTranslateY] = useState(0);
  const [systems, setSystems] = useState([]);
  const [providers, setProviders] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState("All");
  const [selectedBrand, setSelectedBrand] = useState('localhost');
  const [brokenGameIds, setBrokenGameIds] = useState(new Set());
  const vendorMenuRef = useRef(null);

  const defaultSportsOptions = [
    { name: "9wickets", icon: "9wkts.png", link: "/exchange" },
    { name: "Velki", icon: "velki.png", link: "/velki" },
    { name: "SABA", icon: "sabasports.png", code: "08ced9dd788aed11ff3c7f387ae0f063", type: "Sports Game", platform: 'SABASports(IBC)' },
    { name: "United Gaming", icon: "unitedgaming.png", code: "c4b2813f6bbc5abf502ddfb857e604eb", type: "Sports Game", platform: 'UnitedGaming' },
    { name: "LuckSports", icon: "luckysports.png", code: "92b24e4c25107367a80e0fe1a97c24e4", type: "Sports Game", platform: 'LuckySport' },
    { name: "TF", icon: "tf.png", code: "4ee8e0051a035b463b47c3c473ce317d", type: "Esports", platform: 'TF' },
    { name: "Bti", icon: "btisports.png", code: "4d31f1186a81e208c003a7e37411ce35", type: "Sports Game", platform: 'bti' },
    { name: "DPE", icon: "dpe.png", code: "e130116fdc9bcde2dbb31735b6c365d6", type: "Esports", platform: 'DPEsports' },
    { name: "DP", icon: "dpe.png", code: "23c2dca76f87d7b7f239833060c8751e", type: "Sports Game", platform: 'DPSports' },
    { name: "SBO(VS)", icon: "sbosports.png", code: "341827d4370bb198b18364e2d75e6916", type: "VirtualSports ", platform: 'SBO' },
    { name: "SBO", icon: "sbosports.png", code: "07baf9e1388d32cd4cee0c0c91b23020", type: "Sports Game", platform: 'SBO' },
    { name: "CMD", icon: "cmdsports.png", code: "1f7fbf84bf1bcc08c3a7ea27db75f366", type: "Sports", platform: 'CMD' },
    { name: "IA", icon: "iasports.png", code: "68ddcab094a2375b08ca63eb33ef8673", type: "ESports", platform: 'IA' },
  ];
  const [sportsOptions, setSportsOptions] = useState(defaultSportsOptions);
  
  useEffect(() => {
  setActiveKey(tabKey);
}, [tabKey]);

const handleVendorScroll = (direction) => {
  if (!vendorMenuRef.current) return;
  const scrollAmount = 200;
  const container = vendorMenuRef.current;

  if (direction === "next") {
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  } else {
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  }
};


  const menuItems = [
    { key: "hot", className: "list-item-hot", name: "Hot", icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAYAAACcXioiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQdSURBVHgB7ZnLbtNAFIb/iR2ghIBB4qIuoAW6YUORAAkWpUjsC09AERexozxByxMUdoiCCE9QeAJKN91BkVCFVEHDGiG59JKmjX2YsZtL7Tg+k0xbFv2kKPF45vj8c87cHGCPPf4PaMRxsAtkYIpl/yM9zC/IzzB2EHMCQC4IPfLzNhDy2OnBDmBQgPhQ+6mEVLwvdD9/G9uMOQGVTCFS4kBgkh4cHsU2YkyAKLiu/JqK36Gx7RRhMIUkJL4m3FAiRrANmBUg4CbfpHF6mOuHYcwKSH/cJA2bXS8MR4DOtLyvZifbN5pKpscAI0XoickoGBMQLlzEyXGnMQqqHT06PN6uKHMR8DyNqbIhChteP3wawT6/ranWiICg9wnDGk3qUchgKPiWIuhR/i400RYg5/Px2Jyu1fs1Szdiwn08100l/QgIyP0NjVYfFKyyer1fZRAVfzJS5uimktCpHGzO5P4muMhYd2TXH5G9Vmha2fFlfkvzK1qPCLGtXvHSLXKq6kUgg3qOkvck0XnFtRJwawXIEbTRSEl29wT5WvEWWJX71oGL5fD3bwv4dBDaVKyjmxvElvAjwO2VnF93XnHcA7or0Mb2hznVWALY02RWpstAKV7eKIgNDXFq8SLgeYOsetdLYQSiqLK+DWjC2rnyBBDSF5gra2G6JNEdEaBEtR7gDudcnSpgc74fbFlJOX8mpYeVuEaBA4xZyk+PQnoE7BQjHOerVAWo+ioCasxcLiXXJy91VU4X4Hs9ifculPnOKxwvdPzCer0sGhlN2t/MORFHOChHB5oM9D5NOw3YaJdrJWijUibbJOeVMFW+ob/taC8CqvebTZftopx3mtgjKqY1TRdg+bOxsg5yNpFmAoTd+VZCTKwoAVsNOTwBG0eB9RPgEbfpigl3Nq0ZN4VSDUVZPQcsXgX+XpJCjkEfgfecakwB9AwarHVLAefr10pMKuuRASysD4xWPAHi9fIUhCjWClwrsa7ftdV5hYqAn0VrVhtcESiKV67JCEjIv1f77SY3K58IRURZO43WbLXJjjhbQBAFwrvgQh1SEubsUsK7ufJJJLOSCW0GD0JBTCwVwERvHfCskVoqze2P3Sa7ee8HTfMtBvPcvvBbpg5y1lNooCUgOOJZmZuBiPlsLJUoJc+bDmZl41c2dN6yborn6cfIRrRX4uBtgRIBMYuZrjD8VWNyd5FpcXqMRUC1nZHnZSFtKeeZbyK2+IMOoAeHxuR+frRxg7Z4JTlVlMBj05sXyvlp6fwyXog3y22/se7o1aIc2GMoZ3vxMfcO82Ee578lR+HgD4SDX42fqVwBZbu3E+cDH2CI4Ph3am1QvoEY8s96PUuXqL8aCfuPwP6fotj1XabK5wOf5O6toJvruwJNwlkg7Mo/+HvsweQf5jh1Bc04AbwAAAAASUVORK5CYII=" },
    { key: "sports", className: "list-item-sports", name: "Sports", icon: "/icons/nav/nav-sport.svg" },
    { key: "SLOT", className: "list-item-rng", name: "Slots", icon: "/icons/nav/nav-slot.svg" },
    { key: "FH", className: "list-item-fish", name: "Fish", icon: "/icons/nav/nav-fish.svg" },
    { key: "LIVE", className: "list-item-live", name: "Live", icon: "/icons/nav/nav-live.svg" },
    { key: "EGAME", className: "list-item-esports", name: "EGAME", icon: "/icons/nav/nav-egame.svg" },
    { key: "TABLE", className: "list-item-cockfight", name: "Table", icon: "/icons/nav/nav-table.svg" },
    { key: "BINGO", className: "list-item-pvp", name: "Poker", icon: "/icons/nav/nav-poker.svg" },
    { key: "LOTTO", className: "list-item-elott", name: "Lottery", icon: "/icons/nav/nav-lottery.svg" },
  ];
  const activeMenuItem = menuItems.find(item => item.key === activeKey);


  useEffect(() => {
  const selectedSection = menuItems.find(item => item.key === activeKey);

  if (selectedSection && selectedSection.key !== "sports" && selectedSection.key !== "hot") {
    fetchSystems(selectedSection.key);
    handleCasinoClick('', selectedSection.key)
  } else {
    setSystems([]);
    setProviders([]);
  }

  const isMobileDevice = window.innerWidth <= 768;
  setIsMobile(isMobileDevice);
}, [activeKey]);

  // Fetch dynamic sports list from API; fall back to defaults on error
  useEffect(() => {
    const fetchSportsList = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sports-list`);
        if (response.ok) {
          const data = await response.json();
          if (Array.isArray(data) && data.length > 0) {
            setSportsOptions(data);
          }
        }
      } catch (err) {
        // keep defaults on error
      }
    };
    fetchSportsList();
  }, []);

  const gameNames = [
    "Sweet Rush Bonanza",
    "Gates of Olympus",
    "Crazy Time",
    "Aviator",
    "Lucky Spin",
    "Mega Wheel",
    "Treasure Hunt",
    "Dragon Tiger",
    "Roulette X",
    "Book of Gold",
    "Wild Fortune",
    "Hot Fiesta",
  ];

  const gameIcons = [
    "./poster/SPRIBE-EGAME-001.png",
    "./poster/JILI-TABLE-005.png",
    "./poster/EVOLUTION-LIVE-006.png",
    "./poster/MX-LIVE-001.png",
    "./poster/PP-LIVE-001.png",
    "./poster/KM-TABLE-088.png",
    "./poster/SPRIBE-EGAME-001.png",
  ];

  useEffect(() => {
    const newWinners = Array.from({ length: 15 }).map((_, index) => {
      const randomUser = `******${Math.floor(Math.random() * 900 + 100)}`;
      const randomGame = gameNames[Math.floor(Math.random() * gameNames.length)];
      const randomAmount = (Math.floor(Math.random() * 85000) + 15000).toLocaleString();
      const randomIcon = gameIcons[Math.floor(Math.random() * gameIcons.length)];
      return {
        id: index,
        username: randomUser,
        gameName: randomGame,
        amount: randomAmount,
        icon: randomIcon,
      };
    });
    setWinners([...newWinners, ...newWinners]); 
  }, []);
    const [searchQuery, setSearchQuery] = useState("");

const handleSearch = (event) => {
  const query = (event?.target?.value || "").toLowerCase(); // Safe check
  setSearchQuery(query);

  const filtered = games.filter((game) =>
    (game?.name || "").toLowerCase().includes(query) // Safe check for name
  );

  setFilteredGames(filtered);
};


  const handleCasinoClick = async (system, type) => {
  setIsLoading(true);
  setError(null);

  const url = `${process.env.REACT_APP_API_URL}/api/get-games?type=${type}&system=${system}`;
  
console.log(url);
  try {
    const response = await fetch(url);
    const data = await response.json();

    if (response.ok) {
      setGames(data.games || []);
      setFilteredGames(data.games || []);
      
    } else {
      setError(data.message || "Failed to fetch games");
    }
  } catch (error) {
    console.error("Error fetching games:", error);
    setError("An unexpected error occurred while fetching games");
  } finally {
    setIsLoading(false);
  }
};

    const [imageLoaded, setImageLoaded] = useState({});

    const handleImageError = (gameId) => {
      setBrokenGameIds((prev) => {
        const next = new Set(prev);
        next.add(gameId);
        return next;
      });
      setFilteredGames((prev) => prev.filter((game) => (game.uid || game.code) !== gameId));
      setGames((prev) => prev.filter((game) => (game.uid || game.code) !== gameId));
    };
    const handleImageLoad = (gameCode) => {
      setImageLoaded((prev) => ({
        ...prev,
        [gameCode]: true,
      }));
    };


  // 🌀 Auto Vertical Scroll
  useEffect(() => {
    if (!scrollRef.current) return;
    const itemHeight = 70; // px height per winner item (adjust if CSS differs)
    const speed = 30; // ms per pixel scroll
    const interval = setInterval(() => {
      setTranslateY((prev) => {
        const maxScroll = winners.length * itemHeight;
        const newY = prev - 1; // move up by 1px
        return Math.abs(newY) >= maxScroll / 2 ? 0 : newY; // loop reset
      });
    }, speed);
    return () => clearInterval(interval);
  }, [winners]);

   const [isLoading, setIsLoading] = useState(false);
      const [isLoggedIn] = useState(!!localStorage.getItem('token'));
   
      const navigate = useNavigate();
      const [error, setError] = useState(null);
      const origin = window.location.origin;

    // Fetch games data
        const fetchSystems = async (type) => {
          setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
        finally {
              setIsLoading(false);
          }
    };
        const fetchProviders = async (systems) => {
          setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                setProviders(data.data || []);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
        finally {
              setIsLoading(false);
          }
    };
   
    
    const handleGameClick = async (gameCode) => {
        if(!isLoggedIn) {
          navigate('/login');
        }
        setIsLoading(true);
  
          try {
              const token = localStorage.getItem('token');
              const remote_id = localStorage.getItem('remote_id');
              if (!token) {
                  setError('User not logged in');
                  return;
              }
              let parts = gameCode.split('-');

                  
                  let platform = parts[0];   
                  let gameType = parts[1];  

                  if(platform == 'SG'){
                    platform = 'SPADE';
                  }
                 
            
              const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                  method: 'POST',
                  headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                  },
                 
                  body: JSON.stringify({
                     userId : remote_id,
                     externalURL: origin,
                     isMobileLogin: isMobile,
                     gameCode:gameCode,
                     gameType: gameType,
                     platform: platform
                     
                     
                  }),
                 
              });
  
              const data = await response.json();
              if (response.ok) {
                const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
                if (iframeUrl) {
                  navigate('/gamerun', { state: { iframeUrl } });
                } else {
                  setError(data.message || 'An unexpected error occurred');
                }
                  setError(data.message || 'An unexpected error occurred');
              }
          } catch (error) {
              setError('An unexpected error occurred');
          }
          finally {
              setIsLoading(false);
          }
      };
      // filteredGames.some((game) => imageLoaded[game.code] !== false)
      const handleGameClicks = async (gameCode, gamePlatform, gameType) => {

        
       
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }
    
        const token = localStorage.getItem('token');
        const remote_id = localStorage.getItem('remote_id');
    
        if (!token || !remote_id) {
            setError('User not logged in');
            return;
        }
    
        setIsLoading(true);
    
        try {
          if (gamePlatform === 'Lucky' || gamePlatform === 'LuckyS') {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        user_id: remote_id,
                    }),
                });
    
                const dataly = await response.json();
                console.log(`https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`);
                navigate('/gamerun', {
                    state: {
                        iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`,
                    },
                });
    
                return; 
            }
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    userId: remote_id,
                    externalURL: origin,
                    isMobileLogin: isMobile,
                    gameCode: gameCode,
                    gameType: gameType,
                    platform: gamePlatform,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
                const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
                if (iframeUrl) {
                  navigate('/gamerun', { state: { iframeUrl } });
                } else {
                  setError(data.message || 'An unexpected error occurred');
                }
            } else {
                setError(data.message || 'An unexpected error occurred');
            }
        } catch (error) {
            setError('An unexpected error occurred');
        } finally {
            setIsLoading(false);
        }
    };
     const handleExchangeClick = () => {
    
    navigate('/exchange');
  };
    const navRef = useRef(null);
    useEffect(() => {
        const navElement = navRef.current;
    
        // Default: remove 'active' on first load
        if (navElement) {
            navElement.classList.remove('active');
        }
    
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
    
            if (!navElement) return;
    
            if (currentScrollPos > 350) {
                navElement.classList.add('sticky__fixed');
            } else {
                navElement.classList.remove('sticky__fixed');
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useEffect(() => {
        const hostname = (window.location.hostname || '').toLowerCase();
        const origin = (window.location.origin || '').toLowerCase();
        const search = (window.location.search || '').toLowerCase();
        const params = new URLSearchParams(window.location.search);
        const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();
    
        const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
        const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
        const isBoubaji = hostname.includes('malik88') || origin.includes('malik88') || brand.includes('malik88');
    
        const selectedBrand = isBoubaji ? 'malik88' : isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : 'default';
    
        localStorage.setItem('brand', selectedBrand);
        setSelectedBrand(selectedBrand);
      
        
      
      
       
      }, []);

  // Show all games; use a fallback image if poster fails to load
  const visibleGames = filteredGames.filter(
    (game) => !brokenGameIds.has(game.uid || game.code)
  );
      

  return (
    <div className="home-content">
      <div className="sticky-container">
        <div ref={navRef} className="sticky__inner">
          <div className="game-menu-wrap">
            <ul className="game-menu-list hide-scrollbar">
              {menuItems.map((item) => (
                <li
                  key={item.key}
                   onClick={() => {
      if (selectedBrand === 'beetbuzz' && item.key === 'sports') {
        handleExchangeClick();
      } else {
       setActiveKey(item.key); setSelectedProvider('All');
      }
    }}
                  className={`game-menu-item ${item.className} ${
                    activeKey === item.key ? "on" : ""
                  }`}
                >
                  <div className="menu-item-inner">
                    <div className={`game-menu-icon ${item.key}`}>
                      <img
                        className="auto-icon"
                        src={item.icon}
                        alt={item.name}
                        loading="lazy"
                      />
                    </div>
                    <div className="game-menu-name">
                      <span>{item.name}</span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* 🎮 Game Tabs Section */}
      <div className="home-game-tabs">
        <div className="game-tab-content">
          {activeKey === "hot" ? (
          <div className="hot-game-wrap game-content-height">
            <div className="category-games">
              <div className="game-list-wrapper">
                <div className="category-game-list">
                  {/* Example Game */}
                  {slidersFeatures?.map((game, index) => (
                  <div  key={index} className="game-list-item theme-7"  onClick={() => handleGameClick(game.link)}>
                    <div className="game-background">
                      <span
                        className="lazy-load-image-background blur lazy-load-image-loaded"
                        style={{
                          color: "transparent",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}
                          className="img-loading"
                          alt="Aviator"
                        />
                      </span>
                    </div>
                    <div className="game-fav">
                      <svg className="am-icon am-icon-game-fav-normal_eee33a87 am-icon-md favorite_icon">
                        <use xlinkHref="#game-fav-normal_eee33a87" />
                      </svg>
                    </div>
                    <div className="game-name">
                      <span>{game.name}</span>
                    </div>
                  </div>
                  ))}
                  {/* more games can be mapped here later */}
                </div>
              </div>
            </div>
          </div>
           ) :  activeKey === "sports" ? (

        <div className="home-game-tabs">
          <div className="game-tab-content">
            <div className="vendor-game-wrap game-content-height">
              <div className="vendor-game-scroll">
                <div className="vendor-game-list ESPORTS">
                  {sportsOptions.map((sport) => (
                    <div
                      key={sport.name}
                      onClick={() => {
                        if (sport.link) {
                          if (selectedBrand === 'beetbuzz') {
                            handleGameClicks('SABA-VIRTUAL-001', 'SABA', 'VIRTUAL');
                          } else {
                            navigate(sport.link);
                          }
                        } else {
                          handleGameClicks(sport.code, sport.platform, sport.type);
                        }
                      }}
                      className="vendor-game-item"
                    >
                      <div className="vendor-game-img">
                        <span
                          className="lazy-load-image-background blur lazy-load-image-loaded android"
                          style={{ color: 'transparent', display: 'inline-block' }}
                        >
                          <img
                            src={
                              sport.link && selectedBrand === 'malik88'
                                ? '/banner/boubaji.png'
                                : `/icons/${sport.icon}`
                            }
                            className="img-loading"
                            alt={sport.name}
                            loading="lazy"
                          />
                        </span>
                      </div>
                      <div className="vendor-game-name">
                        <span>{sport.name}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

) : (
          <div className="provider-game-list-wrap game-content-height">
  <div className="game-list-filter-wrap">
   
    <div className="search-filter">
      <div className="search-input-wrap">
        <div className="search-input-content">
          <input type="text" className="search-input" placeholder="Search Games"
                      name="search"
                      value={searchQuery}
                      onChange={handleSearch}
                      autocomplete="off"  /><svg className="am-icon am-icon-icon-search_91d48461 am-icon-md search-icon"><use xlinkHref="#icon-search_91d48461" /></svg>
        </div>
      </div>
      <div className="select-bar">
        <div className="select-btn recent">
          <svg className="am-icon am-icon-search-icon-recent_8e17a246 am-icon-md"><use xlinkHref="#search-icon-recent_8e17a246" /></svg>
        </div>
        <div className="select-btn">
          <svg className="am-icon am-icon-search-icon-fav_ae9831cc am-icon-md"><use xlinkHref="#search-icon-fav_ae9831cc" /></svg>
        </div>
        <div className="select-btn">
          <svg className="am-icon am-icon-search-icon-hot_1a29fda0 am-icon-md"><use xlinkHref="#search-icon-hot_1a29fda0" /></svg>
        </div>
      </div>
    </div>
  <div className="vendor-menu-wrap">
  <div className="vendor-menu-scroll">
    {/* ⬅️ Prev Button */}
    <div
      className="menu-nav nav-prev"
      onClick={() => handleVendorScroll("prev")}
      role="button"
      aria-label="Previous slide"
    >
      <svg className="am-icon am-icon-nav-left_f54d9e7f am-icon-md">
        <use xlinkHref="#nav-left_f54d9e7f" />
      </svg>
    </div>

    {/* 🌐 Scrollable provider container */}
    <div
      ref={vendorMenuRef}
      className="vendor-menu-swiper swiper-container-horizontal hide-scrollbar"
      style={{
        display: "flex",
        overflowX: "auto",
        scrollBehavior: "smooth",
        gap: "10px",
      }}
    >
      {/* 🟢 "All" tab */}
      <div
        className={`vendor-menu-item swiper-slide ${selectedProvider === "All" ? "on" : ""}`}
        style={{ flex: "0 0 auto" }}
        onClick={() => setSelectedProvider("All")}
      >
        <span>All</span>
      </div>

      {/* 🧩 Provider tabs */}
      {providers.length > 0 ? (
        providers.map((provider, index) => (
          <div
            key={index}
            className={`vendor-menu-item swiper-slide ${
              selectedProvider === provider.platform ? "on" : ""
            }`}
            style={{ flex: "0 0 auto" }}
            onClick={() => {
              setSelectedProvider(provider.platform);
              handleCasinoClick(
                provider.platform,
                activeMenuItem?.key,
                activeMenuItem?.name
              );
            }}
          >
            <img
              className="menu-icon"
              src={`${process.env.REACT_APP_API_URL}/provider/${provider.platform}.png`}
              loading="lazy"
              alt={provider.platform}
            />
          </div>
        ))
      ) : (
        <p style={{ padding: "10px", color: "#999" }}>No providers</p>
      )}
    </div>

    {/* ➡️ Next Button */}
    <div
      className="menu-nav nav-next"
      onClick={() => handleVendorScroll("next")}
      role="button"
      aria-label="Next slide"
    >
      <svg className="am-icon am-icon-nav-right_b4f324e7 am-icon-md">
        <use xlinkHref="#nav-right_b4f324e7" />
      </svg>
    </div>
  </div>
</div>

  </div>
  <div className="game-list-wrapper">
    {isLoading ? (
    <div className="scroll-loading">
      <svg className="loading-icon" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
        <path opacity="0.2" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
        <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.3s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>) : visibleGames.length === 0 ? (
    <div className="scroll-loading" style={{display:'flex',justifyContent:'center',alignItems:'center',minHeight:'2rem',opacity:0.5}}>
      <svg className="loading-icon" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
        <path opacity="0.2" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
        <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.3s" repeatCount="indefinite" />
        </path>
      </svg>
    </div>
    ) : (
    <div className="category-games">
      <div className="category-game-list">
        {visibleGames.map((game) => {
          const gameId = game.uid || game.code;
          const posterUrl = posterFromSlug(game);
          const isFailed = failedImages[gameId] === true;
          return (
            <div
              className="game-list-item theme-3"
              onClick={() => handleGameClicks(game.uid, game.platform, game.type)}
              key={gameId}
            >
              <div className="game-background">
                <span
                  className="lazy-load-image-background blur lazy-load-image-loaded"
                  style={{ color: 'transparent', display: 'inline-block' }}
                >
                  <img
                    src={isFailed ? EMPTY_IMG : posterUrl}
                    className="img-loading"
                    alt={game.name}
                    onLoad={() => handleImageLoad(game.code)}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      setFailedImages((prev) => ({ ...prev, [gameId]: true }));
                      handleImageError(gameId);
                    }}
                    loading="lazy"
                  />
                </span>
              </div>
              <div className="game-fav">
                <svg className="am-icon am-icon-game-fav-normal_eee33a87 am-icon-md favorite_icon">
                  <use xlinkHref="#game-fav-normal_eee33a87" />
                </svg>
              </div>
              <div className="game-name">
                <span>{game.name}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    )}
    

  </div>
</div>
 )}

          {/* 🏆 Latest Winners Section */}
          <div className="winner-board">
            <div className="winner-title">
              <span>Latest Winners</span>
            </div>
            <div className="winner-content">
              <div className="winner-swiper swiper-container-vertical">
                <div
                  className="swiper-wrapper winner-list"
                  ref={scrollRef}
                  style={{
                    transform: `translateY(${translateY}px)`,
                    transition: "transform 0.1s linear",
                  }}
                >
                  {winners.map((w, index) => (
                    <div key={index} className="winner-item swiper-slide">
                      <div className="swiper-inner">
                        <div className="winner-img">
                          <img className="game-icon" src={w.icon} alt={w.gameName} />
                        </div>
                        <div className="winner-info">
                          <div className="winner-account">
                            <span>{w.username}</span>
                            <span className="just-won"> just won</span>
                          </div>
                          {/* <div className="game-name">{w.gameName}</div> */}
                        </div>
                        <div className="winner-amount">
                          <span className="symbol">৳</span> {w.amount}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <span
                  className="swiper-notification"
                  aria-live="assertive"
                  aria-atomic="true"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default GameInner;